<template lang="html">

  <section class="add-trip">
    <div class="pageHeading">
      <h1>Add a trip to your account</h1>
    </div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">Terms & Agreement</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step  :complete="e1 > 2" step="2">Trip ID</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 1" step="3">Complete!</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-container>

            <h3>Please review our terms & conditions</h3>
            <br>

            <sign-document formid="SIlociNJovwKUyxR" redirect="false" v-on:signresult="(result, message) => {this.AgreedTerms = result; if(result == true){this.e1++;}}">

            </sign-document>
            <hr/>
            <br/>
            <v-btn @click="$router.push('/')"  color="secondary">Previous</v-btn>
          </v-container>

        </v-stepper-content>
        <v-stepper-content step="2">

          <h3>Enter your Trip ID</h3>
          <br>

          <v-card
              class="mb-5"
              color="grey lighten-1"
              height="100px"
          >
            <v-form>
              <v-container>
                <v-layout row wrap>

                  <v-flex xs12 sm5>
                    <v-text-field
                        v-validate="'required'"
                        v-model="tripID"
                        @change="lookupTripInfo"
                        label="Trip ID"
                        required
                    ></v-text-field>

                  </v-flex>
                  <v-flex xs12 sm7>
                    <div style="text-align: left">
                      <p v-if="tripLookup != null">
                        <b>Trip ID: </b> {{tripLookup.tripID}}
                        <br/>
                        <b>Trip Name: </b> {{tripLookup.tripName}}
                        <br/>
                        <b>Departure Date: </b> {{tripLookup.departDate}}</p>
                      <p v-else>Please enter the Trip ID provided to you by the trip director<br>
                        A valid trip ID is required to proceed
                      </p>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card>

          <p v-if="existingTrip == true" style="color:red">You already registered for this trip!</p>

          <v-btn @click="$router.push('/')" flat>Previous</v-btn>
          <v-btn
              :disabled = "tripLookup == null || existingTrip"
              color="primary"
              @click="completeSetup"
          >
            Add This Trip
          </v-btn>

        </v-stepper-content>
        <v-stepper-content step="3">

          <h1>Account Registration Complete</h1>
          <br/>
          <p>Please add all tour participants related to this account (including yourself if you are traveling with the group).</p>
          <p>*Additional tour participants may be added at a later date if necessary*</p>
          <p>Would you like to do that now?</p>

          <v-btn
              color="secondary" dark
              @click="$router.push('/')"
          >
            I will do this later
          </v-btn>
          <v-btn @click="$router.push('/AddTraveler')"
                 color="primary"
          >
            Add a traveler now
          </v-btn>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </section>

</template>

<script lang="js">
import signDocument from '../components/SignDocument'
export default  {
  name: 'add-trip',
  props: [],
  components: {
    signDocument: signDocument
  },
  mounted() {

    this.currentTrips = this.$feathers.get('user').trips
    console.log('current trips', this.currentTrips)

    var vueThis = this;
    if (this.$cookies.isKey("tripToAdd")) {
      this.tripID = this.$cookies.get("tripToAdd");
      console.log('checking if already added trip')

      this.$services.trips.find({ query: {
          $limit: 1,
          tripID: "" + vueThis.tripID
        }
      }).then((result)=>{
        console.log('already result', result, this.currentTrips)
        vueThis.tripLookup = result.data[0]
        if (this.currentTrips.includes(vueThis.tripLookup._id)) {
          this.existingTrip = true;
          vueThis.$cookies.remove("tripToAdd");
          console.log('already added trip!!')
          vueThis.$router.push('/')
        }

      })
    }



  },
  data() {
    return {
      AgreedTerms: false,
      e1: 0,
      currentTrips: [],
      newTrips: [],
      tripID: '',
      existingTrip: false,
      tripLookup: null,
    }
  },
  methods: {
    completeSetup () {
      var vueThis = this;

      vueThis.currentTrips.push('' + vueThis.tripLookup._id)

      console.log('TESTING', vueThis.currentTrips)

     this.$services.users.patch(this.$feathers.get('user')._id, {
        "trips": vueThis.currentTrips
      }).then((test) => {
        console.log('updated', test)
       vueThis.$cookies.remove("tripToAdd");
 vueThis.e1++

      }).catch(function(error){
        console.error('Error!', error);
      });

    },
    lookupTripInfo() {
      var vueThis = this;
      this.existingTrip = false;
      return this.$services.trips.find({ query: {
          $limit: 1,
          tripID: "" + vueThis.tripID
        }
      }).then((result) => {
        console.log('trip look', result.data)
        if(result.data.length > 0 && !result.data[0].disabled) {
          vueThis.tripLookup = result.data[0]
          if (this.currentTrips.includes(vueThis.tripLookup._id)) {
            this.existingTrip = true;
            vueThis.$cookies.remove("tripToAdd");
          }
        }
        else
          vueThis.tripLookup = null
      })
    }

  },
  watch: {
    tripID: function() {
      console.log(this.name)
      this.lookupTripInfo()
    }
  },
  computed: {

  }
}
</script>
<style scoped lang="scss">
  .add-traveler {

  }
  .mainSectionHeadingInList{
    background: #ededed;
    border-bottom: black 1px solid;
  }
  .mainSectionHeadingInList .v-list__tile__title {
    color: black;
    font-size: 20px;
  }
  .mainSectionHeadingInList .v-icon {
    font-size: 30px;
  }
</style>
